import { useEffect } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectSubscriptionAccess } from "../app/auth/authSlice";
import { getPostLoginPath } from "../utils/authRedirect";

/**
 * When user is already logged in, skip the login page and go to returnUrl / state.from / company default.
 */
export default function useRedirectIfAuthenticated() {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const user = useSelector((state) => state.auth.user);
  const profileData = useSelector((state) => state.auth.profileData);
  const subscriptionAccess = useSelector(selectSubscriptionAccess);
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }
    const userForRedirect =
      user && profileData && user.profileData !== profileData
        ? { ...user, profileData }
        : user;
    const redirectTo = getPostLoginPath({
      location,
      searchParams,
      subscriptionAccess,
      user: userForRedirect,
    });
    navigate(redirectTo, { replace: true });
  }, [isAuthenticated, location, searchParams, navigate, subscriptionAccess, user, profileData]);

  return isAuthenticated;
}
